import { render, staticRenderFns } from "./cSwitchBarNew.vue?vue&type=template&id=4084cc5c&scoped=true"
import script from "./cSwitchBarNew.vue?vue&type=script&lang=js"
export * from "./cSwitchBarNew.vue?vue&type=script&lang=js"
import style0 from "./cSwitchBarNew.vue?vue&type=style&index=0&id=4084cc5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084cc5c",
  null
  
)

export default component.exports